import React from 'react';
import { Helmet } from 'react-helmet-async';
import { absoluteUrl, DEFAULT_OG_IMAGE } from '../../service/seoMeta';

/**
 * Per-route title, description, Open Graph tags, and a self-referencing canonical.
 * Call once per public SEO page; do not leave the homepage canonical in index.html.
 */
export default function Seo({
  title,
  description,
  path,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  robots,
}) {
  const url = absoluteUrl(path);
  const ogImage = absoluteUrl(image);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="The Open League" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {robots ? <meta name="robots" content={robots} /> : null}
    </Helmet>
  );
}
